/**
 * The interval used to update the current session
 * @type { number }
 */
export const SESSION_TIMER_UPDATE = 60000 // 1 minute

/**
 * Default time before (in minutes) we should notify the user that his session is expiring
 * @type { number }
 */
export const SESSION_EXPIRING_DEFAULT_TIMEOUT = 5

/**
 * The factor used to decide how much time before we should notify the user that his session is expiring.
 * @type { number }
 */
export const SESSION_DURATION_FACTOR = 0.2